import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const splitText = (el) => {
	el.innerHTML = el.innerHTML.replace(/(\S*)/g, m => {
		if (m.indexOf("&nbsp;") >= 0) {
			let replaceNbsp = m.replace('&nbsp;', ' ');

			return `<div class="word">` +
				replaceNbsp.replace(/(-|#|@)?\S(-|#|@)?/g, "<div class='letter'>$&</div>") +
				`</div>`;
		} else return `<div class="word">` +
			m.replace(/(-|#|@)?\S(-|#|@)?/g, "<div class='letter'>$&</div>") +
			`</div>`;
	});
	return el;
};

function init() {
	let elems = document.querySelectorAll('.title-animation-part');

	elems.forEach(function(item) {
		let elSplit = splitText(item);
		const tl = gsap.timeline();

		let color = item.dataset.color;

		Array.from(elSplit.querySelectorAll('.letter')).forEach((elem) => {
			ScrollTrigger.create({
				animation: tl.to(elem, 0.02, {
					opacity: 1,
					color: color,
				}),
				delay: 200,
				trigger: elem,
				start: 'bottom bottom',
				end: 'bottom top',
				markers: false
			});
		});

		if (item.closest('section').id === 'vulnerabilities') {
			const bisStatEls = document.querySelectorAll('.business-stat__item');

			bisStatEls.forEach(function(item) {
				const line = item.nextSibling;
				const leadContentLine = document.querySelector('.lead .separator');
				const number = item.querySelector('.num');
				const text = item.querySelector('.desc');

				gsap.fromTo([line, leadContentLine], {width: 0}, {width:'100%', delay: 0.5, duration:1});
				gsap.fromTo(number, {y:100, opacity:0}, {y:0, opacity:1, delay: 1, ease: 'Power3.easeOut', duration: 1})
				gsap.fromTo(text, {y:100, opacity:0}, {y:0, opacity:1, delay: 1, ease: 'Power3.easeOut', duration: 1})
			});
		}

		if (item.closest('section').id === 'conference') {
			tl.to(document.querySelector('.grid-table'),
				{y: 0, opacity: 1, ease:'Power3.easeOut', duration: 1}, "<-=0.5"
			);
		}
	});
}

export default {
	init
};
